import type { ReactNode } from "react";
import { HelpHint } from "./HelpHint";

export function PageHeader({
  title,
  description,
  help,
  actions,
  eyebrow,
}: {
  title: ReactNode;
  /** @deprecated 说明文案请用 `help`；传入时与 help 一样收成悬停提示 */
  description?: ReactNode;
  /** 页说明：收成标题旁帮助图标，悬停或聚焦时展示 */
  help?: ReactNode;
  actions?: ReactNode;
  /** Optional section label above the title (e.g. 运维 / 平台运营). */
  eyebrow?: string;
}) {
  const tip = help ?? description;

  return (
    <header className="page-header">
      <div className="page-header-main">
        {eyebrow ? <p className="page-header-eyebrow">{eyebrow}</p> : null}
        <div className="page-header-title-row">
          <h1>{title}</h1>
          <HelpHint label="页面说明">{tip}</HelpHint>
        </div>
      </div>
      {actions ? <div className="header-actions">{actions}</div> : null}
    </header>
  );
}
